import React from "react";
import { hydrateRoot } from "react-dom/client";
import { App } from "../components/App";
import "./index.css";

import { setupViewTransitions, addNavigationLoadingStates } from "./navigation";

// Get initial state passed from server
const initialState = (window as any).__INITIAL_STATE__;

// Hydrate the server-rendered HTML
const container = document.getElementById("app")!;
hydrateRoot(container, <App initialState={initialState} />);

// Setup enhanced navigation
setupViewTransitions();
addNavigationLoadingStates();

console.log("Client hydrated with enhanced navigation!");
